// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/pavilionmenu.less
// module id = 418
// module chunks = 0